import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ItemInView = {
  index: number;
  isInView: boolean;
};

export interface ThumbnailInViewState {
  listOfThumbnails: ItemInView[];
  thumbnailAtTheTopIndex: number;
}

const initialState: ThumbnailInViewState = {
  listOfThumbnails: [],
  thumbnailAtTheTopIndex: 0
};

export const thumbnailsInViewSlice = createSlice({
  name: 'thumbnailsInView',
  initialState,
  reducers: {
    loadListOfThumbnails: (state, action: PayloadAction<ItemInView[]>) => {
      state.listOfThumbnails = action.payload;
    },
    updateThumbnailsInViewList: (state, action: PayloadAction<ItemInView>) => {
      const updatedItems = state.listOfThumbnails.map(item =>
        item.index === action.payload.index ? { ...item, isInView: action.payload.isInView } : item
      );

      const itemsInViewArray = updatedItems.filter(item => item.isInView);

      if (itemsInViewArray && itemsInViewArray.length > 0) {
        const minItemInArray = itemsInViewArray.reduce((prevItem, currentItem) =>
          currentItem.index < prevItem.index ? currentItem : prevItem
        );

        state.listOfThumbnails = updatedItems;
        state.thumbnailAtTheTopIndex = minItemInArray.index;
      }
    }
  }
});

// Action creators are generated for each case reducer function
export const { updateThumbnailsInViewList, loadListOfThumbnails } = thumbnailsInViewSlice.actions;

export default thumbnailsInViewSlice.reducer;
